import { render, staticRenderFns } from "./NProjectsGrid.vue?vue&type=template&id=486496c2&scoped=true&"
import script from "./NProjectsGrid.vue?vue&type=script&lang=js&"
export * from "./NProjectsGrid.vue?vue&type=script&lang=js&"
import style0 from "./NProjectsGrid.vue?vue&type=style&index=0&id=486496c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486496c2",
  null
  
)

export default component.exports